import styled from 'styled-components';

interface ContainerProps {
  widthImg: string;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  min-height: 80vh;
   flex-direction: column;
  align-items: center;
  display: flex;
    padding: 15px 2%;
   img {
    width: ${props => props.widthImg}px;
  }
  sc
    svg {
      margin-right: 16px;
    }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 60vh;
  /* animation: appearFronRight 1s; */

`;

export const MessageContainer = styled.section`
  min-height: 70%;
`;

export const ButtonClose = styled.button`
  padding: 15px 40px;
  min-width: 200px;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    opacity: 0.7;
  }
`

export const Title = styled.h1`
  width: 100%;
  font-size: 30px;
  color: var(--primary);
  text-align: center;
`

export const Message = styled.span`
 padding-top: 40px;
  font-size: 20px;
  width: 100%;
  color: var(--primary);
  text-align: center;
  display: block;
  white-space: pre-line;
`